module.exports = __webpack_public_path__ + "40f7eabeaa4e7e2ae8abb01669970115.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/social/speakers/dan-gebhardt.jpg
// module id = 511
// module chunks = 0